/*
 * The carousel itself is CSS: a scroll-snap track with scroll-snap-stop.
 * This keeps the dots in step with it, lets one be tapped to move the track,
 * and advances the row on a timer — none of which CSS can express.
 */
(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function bind(section) {
    const row = section.querySelector('.pts-reviews__row');
    const dots = Array.from(section.querySelectorAll('.pts-reviews__dot'));
    if (!row || !dots.length || row.dataset.ptsReviewsBound) return;
    row.dataset.ptsReviewsBound = 'true';

    const cards = Array.from(row.children);

    const showing = () => {
      const middle = row.scrollLeft + row.clientWidth / 2;
      let best = 0;
      let closest = Infinity;
      cards.forEach((card, i) => {
        const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - middle);
        if (distance < closest) {
          closest = distance;
          best = i;
        }
      });
      return best;
    };

    const sync = () => {
      const current = showing();
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
    };

    row.addEventListener('scroll', () => {
      clearTimeout(row.ptsSync);
      row.ptsSync = setTimeout(sync, 90);
    }, { passive: true });

    // Scrolls the row and nothing else. scrollIntoView walks up every
    // scrollable ancestor to bring the card into view — including the page —
    // so each advance dragged the window back to this section.
    const goTo = (i) => {
      const card = cards[i];
      const left = Math.max(0, card.offsetLeft - (row.clientWidth - card.offsetWidth) / 2);

      if (REDUCED.matches) {
        const declared = row.style.scrollBehavior;
        row.style.scrollBehavior = 'auto';
        row.scrollLeft = left;
        row.style.scrollBehavior = declared;
        return;
      }

      row.scrollTo({ left, behavior: 'smooth' });
    };

    // Advance on a timer, wrapping back to the first card. Only where the row
    // is actually a carousel: on desktop the cards are a grid, so scrollWidth
    // never exceeds the box and there is nothing to advance.
    const wait = Number(row.dataset.ptsReviewsInterval) || 0;
    let timer = null;

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };

    if (wait && !REDUCED.matches) {
      timer = setInterval(() => {
        // a background tab does not animate a smooth scroll, it queues it
        if (document.hidden) return;
        if (row.scrollWidth <= row.clientWidth + 1) return;
        goTo((showing() + 1) % cards.length);
      }, wait);

      // WCAG 2.2.2: anything that moves on its own has to be stoppable. Once
      // the reader takes hold of the row it is theirs, and the timer is done.
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((event) => {
        row.addEventListener(event, stop, { passive: true, once: true });
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        stop();
        goTo(i);
      });
    });

    sync();
  }

  const init = () => document.querySelectorAll('.pts-reviews').forEach(bind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // the theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.pts-reviews').forEach(bind);
  });
})();
